import { render, staticRenderFns } from "./UiCrud.vue?vue&type=template&id=0f5c2e48&"
import script from "./UiCrud.vue?vue&type=script&lang=js&"
export * from "./UiCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports